module.exports = __webpack_public_path__ + "static/media/Separator.f34b3edd.svg";